import { includes } from "cypress/types/lodash";
import { PcpPrice, HpPrice, Vehicle } from "src/types/loan-application/index";
import useMockBnpProposal from "src/functions/mocks/use-mock-bnp-proposal";
import useMockAlpheraProposal from "app/src/functions/mocks/use-mock-alphera-proposal";
import { useSettingsStore } from "src/stores/settings-store";

export default function usePriceForTerm(vehicle: Vehicle, matrix: PcpPrice[] | HpPrice[], term: number, pcp = false) {
  if (!matrix) {
    return null
  }
  if (pcp && (vehicle.futures === null || vehicle.futures === undefined)) {
    return null;
  }
  if (pcp && (vehicle.cannotPricePCP)) {
    return { value: null, label: "No PCP", subtext: vehicle.cannotPriceReasonPCP }
  }
  if (!pcp && vehicle.cannotPrice) {
    return { value: null, label: "No HP", subtext: vehicle.cannotPriceReason }
  }
  const t = matrix.find(i => i.term === term);

  if (t) {
    return { value: t.monthlyPayment, label: '-' }
  }

  const next = matrix.sort((a, b) => a.term < b.term ? 1 : -1).filter(m => useSettingsStore().termsToShow.includes(m.term))[0];

  return next ? { value: next.monthlyPayment, label: "-1", subtext: `Max ${next.term} mo` } : null
}

